import React from "react";
import { CATEGORIES } from "../lib/categories";
import { CategoryIcon } from "../lib/categoryIcons";
import { Briefcase } from "lucide-react";
import { useLang } from "../lib/i18n";

export default function FilterChips({ counts, active, onChange, total }) {
    const { t } = useLang();
    return (
        <div
            data-testid="filter-chips"
            className="fixed left-0 right-0 z-[350] pointer-events-none top-[calc(env(safe-area-inset-top,0px)+68px)] md:top-[calc(env(safe-area-inset-top,0px)+104px)]"
        >
            <div className="mx-auto max-w-7xl px-2 md:px-6 pointer-events-auto">
                <div className="flex md:flex-wrap gap-1.5 md:gap-2 overflow-x-auto scrollbar-hide py-1 md:py-1.5">
                    <button
                        className={`chip ${active === "all" ? "active" : ""}`}
                        onClick={() => onChange("all")}
                        data-testid="chip-all"
                    >
                        <Briefcase className="w-3.5 h-3.5 md:w-4 md:h-4" />
                        <span>{t("chip.all")}</span>
                        <span className="chip-count">{total}</span>
                    </button>
                    {CATEGORIES.map((c) => (
                        <button
                            key={c.id}
                            className={`chip ${active === c.id ? "active" : ""}`}
                            onClick={() => onChange(c.id)}
                            data-testid={`chip-${c.id}`}
                        >
                            <CategoryIcon
                                catId={c.id}
                                size={14}
                                stroke={active === c.id ? "#ffffff" : undefined}
                            />
                            <span>{t(`cat.${c.id}`)}</span>
                            <span className="chip-count">{counts[c.id] || 0}</span>
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
}
